import { Trans } from "@lingui/macro"
import { Icon } from "@silversea-ssc/ui-components-react"
import React, { useCallback } from "react"
import clsx from "clsx"
import { scrollToElement } from "../scrollToElement"
import styles from "./FloatingFAQLink.module.scss"

export type FloatingFAQLinkVariant = "page" | "bottom-bar"

type Props = {
    variant: FloatingFAQLinkVariant
}

const FloatingFAQLink: React.FC<Props> = ({ variant }) => {
    const onClick = useCallback(() => {
        scrollToElement("faq")
    }, [])

    return (
        <div
            data-content-piece="floating-faq-link"
            className={clsx(styles.container, {
                [styles.bottomBar]: variant === "bottom-bar",
                [styles.page]: variant === "page",
            })}
        >
            <button data-content-piece="faq-link" onClick={onClick} className={styles.button}>
                <Trans>Read our FAQ</Trans>
                <Icon name="arrow-down" size="1x" padding={false} />
            </button>
        </div>
    )
}

export default FloatingFAQLink
